var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoActivity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "64px",
    viewBox: "0 0 80 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / To Be Added in KS / No activity xl") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-To-Be-Added-in-KS-/-No-activity-xl",
    transform: "translate(-26.000000, -34.000000)",
    fill: "#333333"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.0082305,34 C92.5536969,34 92.9958848,34.3097689 92.9958848,34.6918882 L92.995,45.296 L105.871917,70.7867281 C105.935499,70.8980562 105.977808,71.0229516 105.993355,71.1559582 C105.997754,71.2005501 106,71.2386321 106,71.2768461 L106,97.0185958 C106,97.5606104 105.557812,98 105.012346,98 L26.9876543,98 C26.4421879,98 26,97.5606104 26,97.0185958 L26,71.2768461 L26.006692,71.1627928 L26.006692,71.1627928 L26,71.2704107 C26,71.0945442 26.0465533,70.9294821 26.1280829,70.7867281 L39.004,45.296 L39.0041152,34.6918882 C39.0041152,34.3097689 39.4463031,34 39.9917695,34 L92.0082305,34 Z M52.0082305,72.2518149 L27.975,72.251 L27.9753086,96.0371916 L104.024691,96.0371916 L104.024,72.251 L79.9917695,72.2518149 L79.9917695,81.5671105 C79.9917695,82.1091251 79.5495816,82.5485147 79.0041152,82.5485147 L52.9958848,82.5485147 C52.4504184,82.5485147 52.0082305,82.1091251 52.0082305,81.5671105 L52.0082305,72.2518149 Z M91.0205761,35.3837765 L40.9794239,35.3837765 L40.979,70.289 L52.9958848,70.2890065 C53.5413512,70.2890065 53.9835391,70.7283961 53.9835391,71.2704107 L53.9835391,80.5857063 L78.0164609,80.5857063 L78.0164609,71.2704107 C78.0164609,70.7283961 78.4586488,70.2890065 79.0041152,70.2890065 L91.02,70.289 L91.0205761,35.3837765 Z M92.995,49.923 L92.995,70.289 L103.401,70.289 L92.995,49.923 Z M39.004,70.289 L39.004,49.928 L28.598,70.289 L39.004,70.289 Z",
    id: "Icon"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoActivity);
export default __webpack_public_path__ + "static/media/no-activity.0846bf90ee9e68e037315f20df25d560.svg";
export { ForwardRef as ReactComponent };